import React from "react";
import HamburgerButton from "./HamburgerButton";

export default function Navbar({
  user,
  onLogout,
  theme,
  onToggleTheme,
  onOpenMenu,
  menuOpen = false,
}) {
  return (
    <header className="topbar medgen-topbar">
      <div className="topbar-left">
        <div className="topbar-mobile-menu">
          <HamburgerButton open={menuOpen} onClick={onOpenMenu} />
        </div>

        <div className="brand-mark brand-mark-logo">
          <img src="/assets/favicon.png" alt="MedGen" />
        </div>

        <div>
          <h1 className="topbar-title">Medgen Platform</h1>
          <p className="topbar-subtitle">
            Intelligence That Assists Medical Desicions
          </p>
        </div>
      </div>

      <div className="topbar-right">
        <button
          type="button"
          className="btn btn-ghost theme-toggle"
          onClick={onToggleTheme}
        >
          {theme === "light" ? "Dark AI Mode" : "Light Clinical Mode"}
        </button>

        <div className="user-chip">
          <div className="user-avatar">
            {user?.name?.slice(0, 2).toUpperCase() || "US"}
          </div>
          <div>
            <div className="user-name">{user?.name || "User"}</div>
            <div className="user-role">{user?.role || "user"}</div>
          </div>
        </div>

        <button
          type="button"
          className="btn btn-secondary"
          onClick={onLogout}
        >
          Logout
        </button>
      </div>
    </header>
  );
}